import { Tag } from 'antd';
import { useContext, useEffect } from 'react';
import { ContextApp } from '../../../../contexts/ContextApp';

interface Props {
  integrationName: string;
}

const PreintegrationCompleteMessage = ({ integrationName }: Props) => {
  const { t } = useContext(ContextApp);

  useEffect(() => {
    const modalBody = document.querySelector('.ant-modal-body');
    if (modalBody) {
      modalBody.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, []);

  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'center',
        paddingTop: '20px',
      }}
    >
      <span
        className="material-symbols-outlined"
        translate="no"
        style={{ color: '#03729F', marginRight: '10px' }}
      >
        task_alt
      </span>
      <span style={{ fontSize: '16px' }}>{integrationName} completa</span>

      <span
        className="material-symbols-outlined"
        translate="no"
        style={{ color: '#BFBFBF', marginInline: '15px' }}
      >
        arrow_forward
      </span>

      <Tag
        color="#E6F7FF"
        style={{ border: '1px solid #91D5FF', color: '#1890FF' }}
      >
        {t('Tab.Integrated')}
      </Tag>
    </div>
  );
};

export default PreintegrationCompleteMessage;
